import { Button, Card, CardActions, CardContent, Dialog, DialogContent, DialogTitle, Icon, IconButton, Typography } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
// import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
// import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import background from '../../../images/LAOACSLanding.png';
import map from '../../../json/map/landingmap';
import { getEnvVariable } from '../../../modules/environmentalList';
import OwnerRegistration from '../../../modules/ownerregistration/OwnerRegistration';
import Authentication from '../../controls/components/authenticationlogin';
import Map from '../../modules/map/map';
import CardList from './projectJSON';
import ConfirmationPopup from '../../controls/components/confirmationPopup';

import AnnouncementPopup from './AnnouncementPopup';
import axios from 'axios';

const CustomCard = ({ title, icon, buttonText, onButtonClick }) => (
    <Card style={{
        width: '240px',
        margin: '12px',
        textAlign: 'center',
        border: '1px solid rgba(211, 212, 213, 0.5)',
        borderRadius: '15px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        backdropFilter: 'blur(10px)'
    }}>
        <CardContent>
            <Typography
                variant="h7"
                component="div"
            >
                {title}
            </Typography>
            <Icon style={{ fontSize: 60, margin: '20px 0', color: '#555' }}>{icon}</Icon>
        </CardContent>
        <CardActions style={{ justifyContent: 'center' }}>
            {icon === 'login' ? <Authentication /> : (
                <Button style={{ width: '150px', textAlign: 'center' }} variant="contained" color="primary" onClick={onButtonClick} size='meduim'>
                    {buttonText}
                </Button>
            )}
        </CardActions>
    </Card>
);

const CardLoginScreen = () => {
    const [open, setOpen] = useState(false);
    const [signup, setSignup] = useState(false);
    // const [currentIndex, setCurrentIndex] = useState(0);
    // Display all cards at once; no carousel index need
    const [confirmation, setConfirmation] = useState(false);
    const [showAnnouncement, setShowAnnouncement] = useState(true);
    const [announcements, setAnnouncements] = useState([]);
    const history = useHistory();


    const functionMap = {
        "handleSignInClick": () => { },
        "handleShowPermitsClick": () => handleShowPermitsClick(),
        "handleSignUpClick": () => handleSignUpClick(),
        "handleSignConfirmClick": () => handleSignConfirmClick(),
        "handleContactUsClick": () => { window.open("mailto:ODAsupport@LA.Gov") }, // added the la suppport url.
        "handleHelpUsClick": () => { window.open(`${getEnvVariable('HelpUI')}${getEnvVariable('ExternalHelp')}?view=embedded`) },
        "handleHelpUsInternalClick": () => { window.open(`${getEnvVariable('HelpUI')}${getEnvVariable('InternalHelp')}?view=embedded`) },
        "function() { }": () => { }
    };

    useEffect(() => {
        // Password reset logic
        if (window.location.hash.includes("resetpassword")) {
            let loc = history.location.pathname;
            let lastSlash = loc.lastIndexOf("/");
            let lastValue = loc.substring(lastSlash + 1);
            window.location.replace(getEnvVariable('AuthorizationScreen') + 'forgot/resetpassword?guid=' + lastValue + '&ENV=' + process.env.REACT_APP_PROFILE);
        }
        // Fetch active announcements for popup
        const fetchAnnouncements = async () => {
            try {
                const url = getEnvVariable('Admin') + '/api/Announcements/All/Active';
                const response = await axios.get(url);
                const data = Array.isArray(response.data) ? response.data : response.data?.data || [];
                
                // Filter announcements based on ViewerAccess and current portal
                const currentPortal = getEnvVariable('AccessPortal'); // 'I' for Internal, 'E' for External
                const filteredAnnouncements = data.filter(announcement => {
                    const viewerAccess = announcement.ViewerAccess;
                    
                    // If ViewerAccess is 'B' (Both), show for both portals
                    if (viewerAccess === 'B') {
                        return true;
                    }
                    
                    // If ViewerAccess is 'I' (Internal), show only for Internal portal
                    if (viewerAccess === 'I' && currentPortal === 'I') {
                        return true;
                    }
                    
                    // If ViewerAccess is 'E' (External), show only for External portal
                    if (viewerAccess === 'E' && currentPortal === 'E') {
                        return true;
                    }
                    
                    // Otherwise, don't show this announcement
                    return false;
                });
                
                setAnnouncements(filteredAnnouncements);
            } catch (e) {
                setAnnouncements([]);
            }
        };
        fetchAnnouncements();
    }, []);

    const handleShowPermitsClick = () => {
        setOpen(true);
    };
    const handleSignUpClick = () => {
        setSignup(!signup);
        setConfirmation(false);
    };

    const handleClose = () => {
        setOpen(false);
        setSignup(false);
    };

    let items = CardList[(getEnvVariable('ModuleKey') + '_' + getEnvVariable('AccessPortal'))];
    // Removed the carousel functionality to display all cards at once
    // const handlePrevious = () => {
    //     setCurrentIndex((prevIndex) => Math.max(prevIndex - 1, 0));

    // };
    // const handleNext = () => {
    //     setCurrentIndex((prevIndex) =>
    //         Math.min(prevIndex + 1, items.length - 3)
    //     );
    // };

    const handleSignConfirmClick = () => {
        setConfirmation(!confirmation);
    }
    // const visibleItems = items.slice(currentIndex, currentIndex + 4);
    return (
    <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '90vh',
            width: '100vw',
            marginTop: '-55px',
            backgroundImage: `url(${background})`, // Use the imported background image
            backgroundSize: 'cover',
            backgroundPosition: 'center'
        }}>
            {/* <div style={{ marginTop: '20px', }}>
                <IconButton color='primary' onClick={handlePrevious} disabled={currentIndex === 0}><NavigateBeforeIcon /></IconButton></div>

            {visibleItems && visibleItems.map(each => {
                return <CustomCard */}
            {/* Card row container */}
            <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                alignItems: 'stretch',
                width: '100%'
            }}>
                {items && items.map(each => (
                    <CustomCard
                        key={each.title}
                    title={each.title}
                    icon={each.icon}
                    buttonText={each.buttonText}
                    onButtonClick={functionMap[each.onButtonClick]}
                />
 ))}
                {/* <div style={{ marginTop: '20px' }}>
                <IconButton color='primary' onClick={handleNext} disabled={currentIndex === items.length - 4}><NavigateNextIcon /></IconButton> */}

            </div>

            {/* Announcement Popup */}
            <AnnouncementPopup open={showAnnouncement} onClose={() => setShowAnnouncement(false)} announcements={announcements} />

            {signup && <Dialog
                fullScreen
                open={signup}
                onClose={handleClose}
                style={{
                    height: '80vh',
                    width: '88vw',
                    marginTop: '100px',
                    marginLeft: '80px'
                }}
            >
                <DialogTitle>
                    <Typography color='primary' variant='h6'>Create an Account</Typography>
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        color='secondary'
                        style={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <OwnerRegistration />
                </DialogContent>
            </Dialog>}

            {open && <Dialog
                fullScreen
                open={open}
                onClose={handleClose}
                style={{
                    height: '80vh',
                    width: '88vw',
                    marginTop: '100px',
                    marginLeft: '80px'
                }}
            >
                <DialogTitle>
                    <Typography color='primary' variant='h6'>Permits</Typography>
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        color='secondary'
                        style={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Map {...map} height={'68vh'} width={'84vw'} />
                </DialogContent>
            </Dialog>}
            {confirmation && <ConfirmationPopup color='error' value={confirmation ? 'Y' : 'N'} title={'Note:'} description={'If you already have permits with DOTD, please do not create a new account. Instead, contact DOTD to activate your existing account.'}
                onClose={handleSignConfirmClick} onSubmit={handleSignUpClick} labels={['I am New. I will Sign up', 'Okay, I will contact DOTD']} />}
        </div>
    );
};

export default CardLoginScreen;